export default {
  purchaseReturn: {
    search: {
      returnNo: '采购退货单号',
      returnNoPlaceholder: '请输入采购退货单号',
      returnDepartmentCode: '部门',
      returnDepartmentCodePlaceholder: '请选择',
      estimatedOutboundTimeStart: '退货日期起',
      startDatePlaceholder: '请选择',
      estimatedOutboundTimeEnd: '退货日期至',
      endDatePlaceholder: '请选择',
      productName: '商品描述',
      productNamePlaceholder: '请选择商品',
      creatDate: '制单时间',
      creatBy: '制单人',
      outStorage: '退货仓库',
      estimatedOutboundTime: '退货日期',
      company: '公司',
      isReturn: '性质',
      isReturnPlaceholder: '请选择性质',
      departmentCode: '业务部门',
      departmentCodePlaceholder: '请选择业务部门',
      partnerCode: '供应商',
      partnerCodePlaceholder: '请选择供应商',
      returnSalesmanNo: '业务员',
      returnSalesmanNoPlaceholder: '请选择业务员',
      isReturnMoney: '是否退款',
      returnMoney: '退款',
      isReturnMoneyPlaceholder: '请选择是否退款',
      freightTaker: '运费承担',
      freightTakerPlaceholder: '请选择运费承担',
      returnMethod: '退换货方式',
      isDirectDeliver: '是否直拨',
      isDirectDeliverPlaceholder: '请选择直拨条件',
      returnMethodPlaceholder: '请选择退换货方式',
      returnOperatorNo: '操作人',
      returnOperatorNoPlaceholder: '请选择操作人',
      outboundStorageCode: '仓库（出库）',
      outboundStorageCodePlaceholder: '请选择仓库',
      businessInboundNo: '业务入库单号',
      businessInboundNoPlaceholder: '请输入业务入库单号',
      businessInboundBatchNo: '业务入库批次',
      businessInboundBatchNoPlaceholder: '请输入业务入库批次',
      returnStatus: '退换货单状态',
      returnStatusPlaceholder: '请选择退换货单状态',
      status: '状态',
      statusPlaceholder: '请选择状态',
      department: '部门',
      accountingStatus: '入账状态',
      returnQuantity: '退货数量',
      contractNo: '采购合同号',
      originDocNo: '销售退货单号',
      originDocNoPlaceholder: '请输入销售退货单号',
    },
    form: {
      inboundNoNumber: '入库单号',
      returnNo: '退换货出库单',
      isDirectDeliver: '是否直拨',
      returnNoPlaceholder: '系统自动生成',
      isReturn: '性质',
      isReturnPlaceholder: '请选择性质',
      exchangeMethod: '换货方式',
      exchangeMethodPlaceholder: '请选择换货方式',
      returnMethod: '退货方式',
      returnMethodPlaceholder: '请选择退货方式',
      estimatedOutboundTime: '预计出库日期',
      estimatedOutboundTimePlaceholder: '请选择预计出库日期',
      companyName: '公司',
      companyNamePlaceholder: '请选择公司',
      departmentName: '业务部门',
      departmentNamePlaceholder: '请选择业务部门',
      returnOperatorNo: '操作人',
      returnOperatorNoPlaceholder: '请选择操作人',
      returnSalesmanNo: '业务员',
      returnSalesmanNoPlaceholder: '请选择业务员',
      partnerCode: '供应商',
      partnerCodePlaceholder: '请选择供应商',
      supplierStorageCode: '仓库(供应商)',
      supplierStorageCodePlaceholder: '请选择供应商仓库',
      freightTaker: '运费承担',
      freightTakerPlaceholder: '请选择运费承担',
      freightAmount: '运费金额',
      freightAmountPlaceholder: '请输入运费金额',
      isReturnMoney: '退款',
      isReturnMoneyPlaceholder: '请选择是否退款',
      returnMoneyMethod: '退款方式',
      returnMoneyMethodPlaceholder: '请选择运费承担',
      outboundStorageCode: '仓库(出库)',
      outboundStorageCodePlaceholder: '请选择出库仓库',
      directNotEmpty: '直拨类型不能为空',
      gmtCreate: '制单日期',
      gmtCreatePlaceholder: '请选择制单日期',
      exchangeRate: '汇率',
      returnCurrencyName: '货币',
      goodList: {
        productCode: '商品描述',
        productUnit: '单位',
        productCodePlaceholder: '请选择',
        outboundStorageNo: '仓库(出库)',
        outboundStorageNoPlaceholder: '请选择',
        inboundStorageNo: '仓库(入库)',
        inboundStorageNoPlaceholder: '请选择入库仓库',
        businessInboundNo: '业务入库单号',
        businessInboundNoPlaceholder: '请选择业务入库单号',
        returnQuantity: '退货数量',
        returnQuantityPlaceholder: '请输入退货数量',
        returnQuantityMessage: '长度: 1 到 50 个字符',
        exchangeQuantity: '换货数量',
        exchangeQuantityPlaceholder: '请输入换货数量',
        businessInboundBatchNo: '业务入库批次',
        businessInboundBatchNoPlaceholder: '请选择业务入库批次',
        returnAmount: '金额',
        returnAmountPlaceholder: '请输入金额',
        returnCurrency: '币种',
        returnCurrencyPlaceholder: '请选择币种',
        actualOutboundQuantity: '实际出库数量',
        inboundQuantity: '入库数量',
        businessContractPrice: '单价',
        quantity: '可退货数量',
        businessContractPriceNoTax: '不含税单价',
        returnAmountWithoutTax: '不含税金额',
        invoiceQuantity: '已匹配数量',
        nonInvoiceQuantity: '可匹配数量',
        exchangeRate: '汇率',
        contractNo: '采购合同号',
        externalContractNo: '外部合同号',
        contractDetailNo: '采购合同行项目号',
      },
      mark: '备注',
      markPlaceholder: '请输入',
    },
    btnList: {
      add: '新增',
      del: '删除',
      save: '保存',
      commit: '提交审批',
      logisticsTransportation: '物流运输单',
    },
    msg: {
      setWareHouse: '请选择出库仓库',
      setPratner: '请选择供应商',
      delProduct: '请选择要删除的行项目',
      addCapableData: '行数据不能为空',
      salesReturn: '退货',
      barter: '换货',
      yes: '是',
      no: '否',
      logisticsAdded: '物流出库单新增',
      becameEffective: '已生效',
      transTip: '该退换货出库单已生成物流运输单，请选择其他单号',
    },
    route: {
      purchaseReturnList: '采购退换货列表',
      purchaseReturnAdd: '采购退换货新增',
      purchaseReturnEdit: '采购退换货修改',
    },
  },
};
